import { type Question, type QuestionAlternative } from '@/types/question';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getUserInitials = (firstName: string, lastName: string) => {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`;
};

export const getLanguageFullName = (languageCode: string) => {
  const languageNames: Record<string, string> = {
    it: 'Italiano',
    en: 'English',
  };
  return languageNames[languageCode] || languageCode;
};

export const getLanguageFlag = (languageCode: string): string => {
  const flags: Record<string, string> = {
    it: '/flags/flag-it.svg',
    en: '/flags/flag-en.svg',
  };
  return flags[languageCode] || '🌐';
};

export const formatDate = (isoDate: string): string => {
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const getCorrectAnswerIndex = (question: Question) => {
  return question.alternatives?.findIndex(
    (q: QuestionAlternative) => q.correct,
  );
};

// Verifica se il testo contiene un placeholder immagine (&&imageN&&) che ne
// definisce la posizione inline. Se assente, le immagini vanno mostrate sopra il testo.
export function hasImagePlaceholder(text?: string): boolean {
  return !!text && /&&image\d+&&/.test(text);
}

// Legacy images were stored with the global S3 endpoint (s3.amazonaws.com),
// which is incompatible with region-specific buckets (e.g. eu-south-1).
const IMAGES_BUCKET_BASE_URL =
  'https://immaginidomande.s3.eu-south-1.amazonaws.com/';

export function normalizeS3Url(url: string): string {
  // URL parziale (solo la rotta finale): anteponi il base url del bucket.
  if (!/^https?:\/\//.test(url)) {
    return `${IMAGES_BUCKET_BASE_URL}${url.replace(/^\/+/, '')}`;
  }
  return url.replace(
    /^(https:\/\/[^.]+)\.s3\.amazonaws\.com\//,
    '$1.s3.eu-south-1.amazonaws.com/',
  );
}
